export default "__VITE_ASSET__8abe1d48__"